import { repledgeCaseListName } from "assets/properties/properties";
import { CHECK_LOAN_MARKINGS } from "assets/properties/properties";
import { denialReasonsList } from "assets/properties/properties";
import { loanValidationTypeList } from "assets/properties/properties";
import { getDenialMessage } from "utils/denialMessageUtils";
import { sanitizeLoanAccountNumber } from "utils/Utils";
import { parseDate } from "utils/Utils";
const { apiHandler } = require("assets/api");
const { endpoint } = require("assets/api/endpoint");

// Lead Validation API

export const handleLoanValidation = async (authToken,setenabledLeadValidateForNewLoan,toastUpdate,setMinNetWeightValue  ) => {
    const result = await apiHandler({
      url: endpoint.LEAD_VALIDATION_MASTER + loanValidationTypeList?.maxNetWeightPercentage,
      authToken: authToken,
    });
      if(result?.data?.length > 0 && !result?.data?.error_code){
        setenabledLeadValidateForNewLoan(true);
        const minNetWeightValue = result?.data?.[0]?.validationValue;
        setMinNetWeightValue(minNetWeightValue);
      }else{
        setenabledLeadValidateForNewLoan(false);
    }
}


// get Dues Api

export const getPrepledgeLoanDues = async (
  authToken,
  setCallInProgress,
  prePledgeLoan,
  toastUpdate,
  featureFlags,
) => {
  const value = prePledgeLoan?.toUpperCase();
  setCallInProgress(true);
  try {
    // 1️⃣ Get max ROI & interest date
    const roiResponse = await apiHandler({
      url: endpoint.FIND_MAX_ROI_INTEREST_DATE + sanitizeLoanAccountNumber(value, featureFlags?.convertLoanAccountMunber),
      authToken,
    });
    // 2️⃣ Get loan closure dues
    const closureResponse = await apiHandler({
      url:
        endpoint.LOAN_CLOSURE_DUES +
        "?penaltyRate=0&waveOff=0&refund=0" +
        "&interestTillDate=" +
        parseDate(roiResponse?.data?.interestTillDate) +
        "&loanAccountNumber=" +
        value.trim() +
        "&maxRoi=" +
        roiResponse?.data?.maxRoi,
      authToken,
    });
    setCallInProgress(false);
    if (closureResponse?.data?.error_code) {
      toastUpdate("Error", closureResponse?.data?.user_description, true)
      return;
    }
    const totalDues = closureResponse?.data;
    // setLoanActualLoanAmount(totalDues);
    return totalDues;
    // 3️⃣ Calculate processing fee
   
  } catch (error) {
    setCallInProgress(false);
    console.error("SchemeSelectionApi Error:", error);
  }
};


// get Processing Fee Api
export const getProcessingFeeApi = async (authToken, schemeId,toastUpdate,leadBranchCode,setChargeData, setTotalChargeAmount, setCallInProgress, prePledgeLoan, setAddChargeChange, setActualLoanAmount, notEligibleTopUpAccountType, closureTimePayableAdjust, closureTimeExceedAmount, loanApplicationId) => {
    const prePledgeLoanData = await getPrepledgeLoanDues(authToken, setCallInProgress, prePledgeLoan, toastUpdate)
    const value = Number(prePledgeLoanData?.totalDues) - Number(prePledgeLoanData?.interestWaiveOffAmt) - (closureTimePayableAdjust ? Number(prePledgeLoanData?.payableAmount) : 0) + (closureTimeExceedAmount ? Number(prePledgeLoanData?.excessInterestAmount) : 0);
    const feeResponse = await apiHandler({
      url:
        endpoint.CALCULATE_PROCESSING_FEE +
        "?schemeId=" +
        schemeId +
        "&loanAmount=" +
        value +
        "&branchCode=" +
        leadBranchCode + 
        "&isDisbursalTime=true&loanApplicationId=" + 
        loanApplicationId ,
      authToken,
    });
    if (feeResponse?.data?.error_code) {
      toastUpdate("Error", feeResponse?.data?.user_description, true)
    } else {
      const totalChargeAmount = feeResponse?.data?.schemeCalculations?.length > 0
        ? feeResponse.data.schemeCalculations.reduce(
            (sum, item) => sum + (item.adjustedAmount || 0),
            0
          )
        : 0;
      if(notEligibleTopUpAccountType){
        setActualLoanAmount(feeResponse?.data?.actualLoanAmount);
      }
      setTotalChargeAmount(totalChargeAmount);
      setChargeData(feeResponse?.data)
      setAddChargeChange(true);
    }
}

// get Scheme Channel 

  export const getSchemeChannelList = async (authToken,toastUpdate , dispatch, saveSchemeChannel, setSchemeChannel) => {
      const result = await apiHandler({
        url: endpoint.ADMIN_SCHEME_CHANNEL_ALL,
        authToken: authToken,
      });
      if (result?.data?.error_code) {
        toastUpdate("Error", result?.data?.user_description, true);
      } else {
        setSchemeChannel(result?.data)
        dispatch(
          saveSchemeChannel({
            schemeChannel: result.data,
          })
        );
      }
  };

// get Personal Loan Eligiblity

 export const personalLoanElegiblity = async (authToken, loanApplicationId,actualLoanAmount,selectedScheme, setPersonalElegibleLoanAmount ) => {
    const res = await apiHandler({
      url:
        endpoint.PERSONAL_LOAN_ELEGIBLITY +
        loanApplicationId +
        "/amount/" +
        actualLoanAmount +
        "/scheme/" +
        selectedScheme?.schemeCode +
        "/calculate-pl-amt",
      method: "POST",
      authToken: authToken,
    });
    if (res?.data) {
      setPersonalElegibleLoanAmount(res?.data?.eligibleLoanAmt);
    }
  };

// get User Details

 export const GetUserDetails = async (setCallInProgress, authToken, toastUpdate) => {
    setCallInProgress(true);
    const res = await apiHandler({
      url: endpoint.USER_FIND_ALL,
      authToken: authToken,
    });
    setCallInProgress(false);
    if (res?.data?.error_code) {
      toastUpdate("Error", res?.data?.user_description, true);
      return;
    } else {
      const result = await apiHandler({
        url: endpoint.USER_DETAIL,
        authToken: authToken,
      });
      const data = res?.data?.filter((item) => item.active === true);
      let newArray = [...data, result?.data];
      // setreferralNameList(newArray);
      return newArray
    }
  };

  // Get Total Amount in year

   export const getTotalLoanAmount = async (customerId,authToken ) => {
      const result = await apiHandler({
        url: endpoint.TOTAL_LOAN_IN_YEAR + customerId + "/total-loan",
        authToken: authToken,
      });
      if (!result?.data?.error_code) {
        return result?.data?.totalLoanTaken
      }
    };


// Check TopUp and Renewal Case Eleigible

 export const getLoanLtvAmount = async (setCallInProgress, subStatus, mobileNum, prePledgeLoan, authToken, toastUpdate, setMaxLoanAmountPercentage, enabledApiBasedLtv, enabledLtvSchemeBased) =>{
     setCallInProgress(true);
        const isTopUp = subStatus === repledgeCaseListName?.topUp;
        const isRenewal = subStatus === repledgeCaseListName?.renew;
    
        const loanDetails = await apiHandler({
          url:
            endpoint.GET_LOAN_TOP_AND_RENEAL_DETAILS +
            mobileNum +
            `/renewal/${isRenewal}/topup/${isTopUp}?source=WEB&loanAccountNumber=${prePledgeLoan}`,
          method: "GET",
          authToken,
        });
        setCallInProgress(false);
        if (loanDetails?.data?.error_code) {
          toastUpdate("Error", loanDetails?.data?.user_description, true);
        }else{
          if (!loanDetails?.data?.length) {
           toastUpdate("Error", "No Data Found", true);
           return false;
         }
          if (!Array.isArray(loanDetails?.data)) return true;
          const loans = loanDetails?.data;
          const totalLoanAmount = loans?.find(loan => loan?.loanAccountNumber === prePledgeLoan)
          const hasFeatureDisabled = totalLoanAmount?.topUpDenialReason === "FEATURE_DISABLED" || totalLoanAmount?.renewableDenialReason === "FEATURE_DISABLED";
          if (hasFeatureDisabled) {
              toastUpdate("Error", `${subStatus} feature is disabled`, true);
                return false;
          }
          if (totalLoanAmount?.loanStatus === "CLOSED") {
            toastUpdate("Error", "Loan is closed", true);
            return false;
          }
            if (
            (isTopUp && totalLoanAmount?.topupEligible === false) ||
            (isRenewal && totalLoanAmount?.renewalEligible === false)
          ) {
              const denialReason = isTopUp ? totalLoanAmount?.topUpDenialReason : totalLoanAmount?.renewableDenialReason;
              const type = isRenewal ? "Renewal" : "TopUp"
              if(denialReason){
                  toastUpdate("Error", getDenialMessage(denialReason, loans, type, denialReasonsList, CHECK_LOAN_MARKINGS), true)
                }else{
                  toastUpdate("Error", `You are not eligible for ${type}`, true)
                }
              return false
          }
        }
  }
   export const checkCollateralWeight = async (customerId,authToken,groupDetails,setCallInProgress,toastUpdate ) => {
      setCallInProgress(true);
      const result = await apiHandler({
        url: endpoint.CHECK_ADDITIONAL_COLLATERAL_TYPE,
        method: "POST",
        authToken: authToken,
        data:{
          customerId: customerId,
          ornaments: groupDetails,
        }
      });
      setCallInProgress(false);
      if (result?.data?.error_code) {
        toastUpdate("Error", result?.data?.user_description, true);
        return false;
      }else{
        return true
      }
    };

    export const checkCollateralType = async (
      customerId,
      authToken,
      groupDetails,
      setCallInProgress,
      toastUpdate,
      mobileNum
    ) => {
      if (!customerId) {
        setCallInProgress(true);
        const res = await apiHandler({
          url: endpoint.SEARCH_PROFILE + mobileNum?.trim(),
          authToken,
        });
        setCallInProgress(false);
        if (!res?.data?.error_code) {
          return checkCollateralWeight(
            res?.data?.[0]?.customerId,
            authToken,
            groupDetails,
            setCallInProgress,
            toastUpdate
          );
        }
        return true;
      }
      return checkCollateralWeight(
        customerId,
        authToken,
        groupDetails,
        setCallInProgress,
        toastUpdate
      );
    };

  // return diamond Amout

  export const getDiamondAmount = async (caretColor,caretGrade, authToken ) => {
      const result = await apiHandler({
        url: endpoint.GET_DIAMOND_CARET_AMOUNT + "?caretGrade=" + caretGrade + "&caretColor=" + caretColor,
        authToken: authToken,
      });
      if (!result?.data?.error_code && result?.data !== "") {
        return result?.data
      }
    };